import { render, staticRenderFns } from "./HomeFeedPendingAction.vue?vue&type=template&id=63bc4f52&scoped=true"
import script from "./HomeFeedPendingAction.vue?vue&type=script&lang=js"
export * from "./HomeFeedPendingAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc4f52",
  null
  
)

export default component.exports